import { createContext } from 'react';
import { ThemeOption } from '../types/theme';

interface ThemeContextType {
    themeName: string;
    setThemeName: (themeName: string) => void;
    themeOptions: ThemeOption[];
}

// Create a context with default values
export const ThemeContext = createContext<ThemeContextType>({
    themeName: 'Default Blue',
    setThemeName: () => { },
    themeOptions: [],
}); 